import Vue from 'vue'
import VueRouter from 'vue-router'
import routesList from './routers.js'
import store from '@/store'
Vue.use(VueRouter)

const routes = routesList
// [
//   {
//     path: '/',
//     name: 'home',
//     component: HomeView
//   },
//   // {
//   //   path: '/about',
//   //   name: 'about',
//   //   // route level code-splitting
//   //   // this generates a separate chunk (about.[hash].js) for this route
//   //   // which is lazy-loaded when the route is visited.
//   //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
//   // }
// ]
const createRouter =()=> new VueRouter({
  mode: 'history',
  base: '/WalDB/',
  routes
})
const router = createRouter()
router.afterEach((to,from)=>{
  store.commit('log/setMonitoring',{
    title:"切换页面",
    formPage:from.path,
    toPage:to.path,
  })
})
router.beforeEach((to, from, next) => {
  console.log(to, from)
  // if (getCookies('Admin-Token')) { // 判断缓存里面是否有 Token 
  //   resetRouter()
    next()
  // } else {
  //   console.log("111")
  //   //   // removeCookies()
  //   //   // router.push({ path: "/"  })
  //   if (to.path === '/login') next()
  //   else next('/login')


  // }
})
export function resetRouter() {
  const newRouter = createRouter()
  var routerL=[]
  for(var i=0;i<newRouter.options.routes.length;i++){//循环权限
    // if(newRouter.options.routes[i].role){//判断权限
    //   console.log(newRouter.options.routes[i].role.includes(Number(getCookies('Admin-id'))),getCookies('Admin-id'))
    //   if(newRouter.options.routes[i].role.includes(Number(getCookies('Admin-id')))){
    //     routerL.push(newRouter.options.routes[i])
    //   }
    // }else{
      routerL.push(newRouter.options.routes[i])
    // }
   
  }
  newRouter.options.routes=routerL
  router.matcher = newRouter.matcher // reset router
}
export default router
